// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"31":"fd2f0ea0","439":"73138bcd","571":"46598e8d","847":"ce1fcbcb","865":"1e59772c","978":"f58b3d11"}[chunkId] + ".chunk.js";
};